function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 86"
}, React.createElement("path", {
  "data-name": "Union 3",
  d: "M10.354 10.353l-10 10 10-10-10-10 10 10 10-10-10 10 10 10z",
  fill: "none",
  stroke: "#565d6f"
}));

function SvgXIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 20.707 20.707",
    width: "1em",
    height: "1em",
    ref: svgRef
  }, props), _ref2);
}

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgXIcon, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMC43MDcgMjAuNzA3Ij4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNscy0xIHsKICAgICAgICBmaWxsOiBub25lOwogICAgICAgIHN0cm9rZTogIzU2NWQ2ZjsKICAgICAgfQogICAgPC9zdHlsZT4KICA8L2RlZnM+CiAgPGcgaWQ9Ikdyb3VwXzg2IiBkYXRhLW5hbWU9Ikdyb3VwIDg2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjkxLjk2IC02MDkuOTYxKSI+CiAgICA8cGF0aCBpZD0iVW5pb25fMyIgZGF0YS1uYW1lPSJVbmlvbiAzIiBjbGFzcz0iY2xzLTEiIGQ9Ik0xMCwxMCwwLDIwLDEwLDEwLDAsMCwxMCwxMCwyMCwwLDEwLDEwLDIwLDIwWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjkyLjMxNCA2MTAuMzE0KSIvPgogIDwvZz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };